import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import { routes as academyRoutes } from './academy/academy.routes';
import campaignsRoutes from './campaigns/campaigns.routes';
// LIA Agents routes
import { routes as liaAgentsRoutes } from './lia-agents/lia-agents.routes';
// AI Agents (Agno nativo) routes
import { routes as aiAgentsRoutes } from './agents/agents.routes';
import dashboardAppsRoutes from './dashboard_apps/dashboard_apps.routes';
import kanbanRoutes from './kanban/kanban.routes';
import socialRoutes from './social/social.routes';
import aiStudioRoutes from './ai-studio/ai-studio.routes';
import { routes as taskRoutes } from './tasks/tasks.routes';
import { routes as workspaceRoutes } from './workspace/workspace.routes';
import { routes as companiesRoutes } from './companies/routes';
import { routes as prospectingHubRoutes } from './prospecting-hub/routes';
import { routes as metaAdsRoutes } from './meta-ads/routes';
import { routes as marketingRoutes } from './marketing/marketing.routes';
import { routes as dealsRoutes } from './deals/routes';
import { routes as crmHomeRoutes } from './crm/routes';
import { routes as mainDashboardRoutes } from './Dashboard/routes';
import { routes as supervisionRoutes } from './supervision/routes';
import { routes as changelogRoutes } from './changelog/routes';
import revenda from './revenda/revenda.routes';
// Chat Rooms routes
import chatRoomsRoutes from '../chatRooms';
import AppContainer from './Dashboard.vue';
import Suspended from './suspended/Index.vue';
import Paywall from './paywall/Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      children: [
        ...mainDashboardRoutes,
        ...supervisionRoutes,
        ...contactRoutes,
        ...companiesRoutes,
        ...prospectingHubRoutes,
        ...metaAdsRoutes,
        ...marketingRoutes,
        ...dealsRoutes,
        ...crmHomeRoutes,
        ...inboxRoutes,
        ...conversation.routes,
        ...kanbanRoutes.routes,
        ...socialRoutes.routes,
        ...aiStudioRoutes.routes,
        ...taskRoutes,
        ...workspaceRoutes,
        ...dashboardAppsRoutes.routes,
        ...settings.routes,
        ...searchRoutes,
        ...notificationRoutes,
        ...helpcenterRoutes.routes,
        ...academyRoutes,
        ...campaignsRoutes.routes,
        ...liaAgentsRoutes,
        ...aiAgentsRoutes,
        ...chatRoomsRoutes.routes,
        ...(chatRoomsRoutes.settingsRoutes || []),
        ...changelogRoutes,
        ...revenda.routes,
      ],
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Suspended,
    },
    {
      path: frontendURL('accounts/:accountId/billing/paywall'),
      name: 'billing_paywall',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Paywall,
    },
  ],
};
